import { getVenueTypeTranslated } from '@bridebook/web/app-shared/lib/supplier/utils/get-venue-type-translated';
import { getI18n } from '@bridebook/web/lib/i18n/getI18n';

const formatter = (prop: string, val: number): number | null => {
  const num: number = parseInt(prop, 10);
  return typeof num === 'number' && num > val ? num : null;
};

const formatBridalSuite = (val: string): string | null => {
  const i18n = getI18n();
  switch (val) {
    case 'honeymoonSuite':
      return i18n.t('supplier:msg.honeymoonSuite');
    case 'standardRoom':
      return i18n.t('supplier:msg.standardRoom');
    case 'changingOnly':
      return i18n.t('supplier:msg.changingOnly');
    case 'bridalSuiteNone':
      return i18n.t('supplier:none');
    default:
      return null;
  }
};

const getDefaultWeddingHostedLabels = (): [string, string, string, string] => {
  const i18n = getI18n();
  return [
    i18n.t('supplier:weddingHosted.less10'),
    i18n.t('supplier:weddingHosted.between10And30'),
    i18n.t('supplier:weddingHosted.between30And50'),
    i18n.t('supplier:weddingHosted.more50'),
  ];
};

const getShortWeddingHostedLabels = (): [string, string, string, string] => {
  const i18n = getI18n();
  return [i18n.t('supplier:weddingHosted.less10'), '10+', '30+', '50+'];
};

const formatWeddingsHosted = (
  value: [number, number],
  labels: [string, string, string, string],
) => {
  const [min, max] = value;

  switch (true) {
    case min === 0 && max === 10:
      return labels[0];
    case min === 10 && max === 30:
      return labels[1];
    case min === 30 && max === 50:
      return labels[2];
    case min === 50:
      return labels[3];
    default:
      return null;
  }
};

export const isDefined = (val: any): boolean => {
  const i18n = getI18n();

  return (
    val !== 0 &&
    val !== '' &&
    val != null &&
    val !== i18n.t('supplier:no') &&
    val !== 'No' &&
    val &&
    val !== 'None' &&
    val !== i18n.t('supplier:none')
  );
};

export const hasData = (section: Array<any>): boolean =>
  section.map((val) => isDefined(val)).filter((val) => val).length !== 0;

export const applyFormatter = (prop: string, val: any): string | number | null => {
  if (!val) return null;

  switch (prop) {
    case 'typeDetails.venue.company.insurance':
    case 'typeDetails.venue.time.extension':
    case 'company.insurance':
      return getI18n().t('supplier:yes') as string;
    case 'typeDetails.venue.accommodation.bridalSuite':
      return formatBridalSuite(val);
    case 'typeDetails.venue':
      return getVenueTypeTranslated(val);
    case 'company.established':
      return formatter(val, 1000);
    case 'company.teamSize':
      return formatter(val, 0);
    case 'company.weddingsHosted':
      return formatWeddingsHosted(val, getDefaultWeddingHostedLabels());
    case 'company.weddingsHostedShort':
      return formatWeddingsHosted(val, getShortWeddingHostedLabels());
    default:
      return val;
  }
};

export const formatBbGift = (value?: string, bbGiftOther?: string): string | null => {
  const i18n = getI18n();
  switch (value) {
    case 'freeBottleOfChampagne':
      return i18n.t('supplier:bbGift.champagne');
    case 'none':
      return i18n.t('supplier:none');
    case 'other':
      return bbGiftOther || '';
    case '':
      return null;
    default:
      return null;
  }
};
